import React from 'react';

export default function TransactionTabs({ tabs, activeTab, onChange }) {
  return (
    <div className="sticky top-0 z-20 rounded-xl border border-[var(--hp-color-border-muted)] bg-surface/95 px-2 shadow-hp-sm backdrop-blur">
      <nav className="flex overflow-x-auto custom-scrollbar">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              inline-flex shrink-0 items-center gap-2 border-b-2 px-4 py-3
              text-sm font-medium transition-colors
              ${
                activeTab === tab.id
                  ? "border-[var(--hp-info-500)] text-primary"
                  : "border-transparent text-subtle hover:text-primary"
              }
            `}
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}

            {typeof tab.count === "number" && (
              <span className="rounded-full bg-surface-muted px-2 py-0.5 text-[11px] tabular-nums text-primary font-semibold">
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
